// Mock customer data for pharmacy-side staff application
// 8 customers with varied Australian pharmacy profiles

export const customers = [
  {
    id: 'CUST001',
    name: 'Sarah Johnson',
    dateOfBirth: '1980-03-15',
    gender: 'Female',
    phone: '+61 412 345 678',
    email: 'sarah.johnson@email.com',
    address: '42 Wallaby Way, Melbourne VIC 3000',
    medicareNumber: '2736 41283 2',
    concessionCard: 'Healthcare Card',
    ihi: '8003608333333333',
    allergies: [
      { substance: 'Penicillin', severity: 'Moderate', reaction: 'Skin rash, hives' },
      { substance: 'Sulfonamides', severity: 'Mild', reaction: 'Nausea' }
    ],
    conditions: [
      { name: 'Type 2 Diabetes Mellitus', diagnosedDate: '2020-03-15', status: 'Active', managedBy: 'Dr. Sarah Smith' },
      { name: 'Essential Hypertension', diagnosedDate: '2019-08-20', status: 'Active', managedBy: 'Dr. John Johnson' },
      { name: 'Major Depressive Disorder', diagnosedDate: '2024-01-10', status: 'Active', managedBy: 'Dr. Emily Chen' },
      { name: 'Seasonal Allergic Rhinitis', diagnosedDate: '2015-09-01', status: 'Active', managedBy: 'Dr. Sarah Smith' }
    ],
    prescriptions: [
      {
        id: 'RX001',
        medication: 'Metformin 500mg',
        doctor: 'Dr. Sarah Smith',
        doctorProviderNumber: '2450123B',
        clinic: 'Melbourne Medical Centre',
        issued: '2025-12-01',
        expires: '2026-08-01',
        refillsRemaining: 2,
        totalRefills: 5,
        status: 'Active',
        isRepeat: true,
        lastFilledDate: '2026-02-05',
        pbs: true,
        pbsItemCode: '08552L',
        pbsAuthority: false,
        streamlinedAuth: true,
        brandOptions: ['Glucophage', 'Diabex', 'Diaformin'],
        dispensedBrand: 'Glucophage',
        erxScriptToken: 'ERXT-2025-001-MET',
        erxScriptType: 'eRx',
        erxBarcodeRef: '93310001234567',
        dosageInstructions: '1 tablet twice daily with meals',
        quantityPrescribed: 60,
        quantityDispensed: 60,
        conditionTreated: 'Type 2 Diabetes Mellitus',
        safetyNetContribution: 6.80,
        concessionApplied: true,
        notes: 'Patient tolerating well. Monitor HbA1c in 3 months.'
      },
      {
        id: 'RX002',
        medication: 'Lisinopril 10mg',
        doctor: 'Dr. John Johnson',
        doctorProviderNumber: '2450456C',
        clinic: 'Heart Health Specialists',
        issued: '2025-05-15',
        expires: '2025-11-26',
        refillsRemaining: 0,
        totalRefills: 3,
        status: 'Expired',
        isRepeat: true,
        lastFilledDate: '2025-06-20',
        pbs: true,
        pbsItemCode: '01015E',
        pbsAuthority: false,
        streamlinedAuth: false,
        brandOptions: ['Zestril', 'Prinivil', 'Lisodur'],
        dispensedBrand: 'Zestril',
        erxScriptToken: 'ERXT-2025-002-LIS',
        erxScriptType: 'eRx',
        erxBarcodeRef: '93310001234568',
        dosageInstructions: '1 tablet daily in the morning',
        quantityPrescribed: 30,
        quantityDispensed: 30,
        conditionTreated: 'Essential Hypertension',
        safetyNetContribution: 6.80,
        concessionApplied: true,
        notes: 'BP well controlled. Continue current dose.'
      },
      {
        id: 'RX003',
        medication: 'Sertraline 50mg',
        doctor: 'Dr. Emily Chen',
        doctorProviderNumber: '2450789D',
        clinic: 'Mindful Health Practice',
        issued: '2025-12-01',
        expires: '2026-10-01',
        refillsRemaining: 3,
        totalRefills: 5,
        status: 'Active',
        isRepeat: true,
        lastFilledDate: '2026-01-18',
        pbs: true,
        pbsItemCode: '08803H',
        pbsAuthority: false,
        streamlinedAuth: true,
        brandOptions: ['Zoloft', 'Setrona', 'Sertralin'],
        dispensedBrand: 'Zoloft',
        erxScriptToken: 'ERXT-2025-003-SER',
        erxScriptType: 'eRx',
        erxBarcodeRef: '93310001234569',
        dosageInstructions: '1 tablet daily with food, preferably in the morning',
        quantityPrescribed: 30,
        quantityDispensed: 30,
        conditionTreated: 'Major Depressive Disorder',
        safetyNetContribution: 6.80,
        concessionApplied: true,
        notes: 'Dose stable. Review in 6 weeks.'
      }
    ],
    pbsSafetyNet: {
      currentSpend: 832.50,
      threshold: 1694.00,
      scriptsThisYear: 12,
      safetyNetReached: false
    },
    dispensingHistory: [
      { medication: 'Metformin 500mg', date: '2025-06-15', quantity: 60, pbsCost: 6.80, dispensedBy: 'Alex Pharmacist' },
      { medication: 'Lisinopril 10mg', date: '2025-06-20', quantity: 30, pbsCost: 6.80, dispensedBy: 'Alex Pharmacist' },
      { medication: 'Sertraline 50mg', date: '2025-07-05', quantity: 30, pbsCost: 6.80, dispensedBy: 'Alex Pharmacist' },
      { medication: 'Metformin 500mg', date: '2025-05-15', quantity: 60, pbsCost: 6.80, dispensedBy: 'Alex Pharmacist' },
      { medication: 'Lisinopril 10mg', date: '2025-05-20', quantity: 30, pbsCost: 6.80, dispensedBy: 'Alex Pharmacist' },
      { medication: 'Cetirizine 10mg', date: '2025-04-10', quantity: 30, pbsCost: null, dispensedBy: 'Alex Pharmacist' }
    ],
    consent: { myHealthRecord: true, pbsClaiming: true, marketingComms: false },
    notes: 'Regular patient. Reliable medication adherence. Prefers morning pickups.',
    immunisations: [
      { name: 'COVID-19 (Pfizer)', date: '2024-04-15', status: 'Completed' },
      { name: 'Influenza', date: '2025-04-01', status: 'Completed' },
      { name: 'Pneumococcal', date: '2024-10-20', status: 'Completed' }
    ],
    pathologyResults: [
      { test: 'HbA1c', result: '7.2%', date: '2025-06-10', referenceRange: '< 7.0%', status: 'Slightly Elevated' },
      { test: 'Blood Pressure', result: '128/82 mmHg', date: '2025-06-10', referenceRange: '< 140/90', status: 'Normal' },
      { test: 'Total Cholesterol', result: '5.1 mmol/L', date: '2025-06-10', referenceRange: '< 5.5', status: 'Normal' },
      { test: 'eGFR', result: '85 mL/min', date: '2025-06-10', referenceRange: '> 60', status: 'Normal' },
      { test: 'Liver Function (ALT)', result: '28 U/L', date: '2025-06-10', referenceRange: '< 40', status: 'Normal' }
    ],
    sharedHealthSummary: {
      lastUpdated: '2025-06-15',
      author: 'Dr. Sarah Smith',
      clinic: 'Melbourne Medical Centre',
      summary: 'Active conditions: T2DM (HbA1c 7.2% — slightly above target), essential hypertension (well controlled on Lisinopril), MDD (stable on Sertraline 50mg), seasonal allergic rhinitis. Allergy: Penicillin (rash/hives), Sulfonamides (nausea). Healthcare Card holder. Good medication adherence.'
    },
    adverseReactions: [
      { substance: 'Penicillin', reaction: 'Generalised urticaria and maculopapular rash', date: '2015-03-20', severity: 'Moderate', reporter: 'Dr. Sarah Smith', status: 'Active' },
      { substance: 'Sulfonamides (Co-trimoxazole)', reaction: 'Nausea and GI upset', date: '2018-07-10', severity: 'Mild', reporter: 'Dr. Sarah Smith', status: 'Active' }
    ],
    carePlans: [
      { title: 'Diabetes Management Plan (GP Management Plan)', date: '2025-01-15', author: 'Dr. Sarah Smith', status: 'Active', reviewDate: '2025-07-15', summary: 'Target HbA1c <7%. Metformin 500mg BD. Diet: low GI, reduce refined sugars. Exercise: 30 min moderate activity 5 days/week. Pathology: HbA1c, lipids, eGFR, LFT 3-monthly. Podiatry annually. Eye review annually.' },
      { title: 'Mental Health Treatment Plan', date: '2025-01-10', author: 'Dr. Emily Chen', status: 'Active', reviewDate: '2025-07-10', summary: 'MDD — PHQ-9 improved from 18 to 8. Sertraline 50mg daily (continue). Fortnightly psychology sessions (CBT). Crisis plan documented with Lifeline/000. Review 6-weekly with psychiatrist.' }
    ],
    diagnosticImaging: [
      { title: 'Retinal Photography — Diabetic Eye Screen', date: '2025-03-10', facility: 'Melbourne Eye Specialists', referredBy: 'Dr. Sarah Smith', findings: 'No evidence of diabetic retinopathy. No macular oedema. Optic discs normal. Recommend annual review.', status: 'Reviewed' }
    ],
    dischargeSummaries: [],
    eReferrals: [
      { from: 'Dr. Sarah Smith', to: 'Dr. Emily Chen — Psychiatrist', date: '2024-01-05', reason: 'Assessment and management of depressive symptoms — PHQ-9 score 18', urgency: 'Semi-urgent', status: 'Accepted' },
      { from: 'Dr. Sarah Smith', to: 'Podiatry Clinic — Melbourne Medical Centre', date: '2025-01-20', reason: 'Annual diabetic foot assessment', urgency: 'Routine', status: 'Completed' }
    ],
    eventSummaries: [
      { title: 'Diabetes Annual Cycle of Care', date: '2025-06-10', provider: 'Dr. Sarah Smith', clinic: 'Melbourne Medical Centre', summary: 'HbA1c 7.2% (slightly above target — dietary review given). BP 128/82 (controlled). Lipids normal. eGFR 85 (stable). LFT normal. Diabetic foot exam: normal sensation, no ulcers. Eye screen: no retinopathy. Continue current medications.' },
      { title: 'Psychiatry Review', date: '2025-03-15', provider: 'Dr. Emily Chen', clinic: 'Mindful Health Practice', summary: 'PHQ-9 score 8 (mild). Responding well to Sertraline 50mg. Sleep improved. No suicidal ideation. Continue current dose. Psychology sessions ongoing. Review in 3 months.' }
    ],
    goalsOfCare: [],
    specialistLetters: [
      { from: 'Dr. Emily Chen — Psychiatrist', to: 'Dr. Sarah Smith — GP', date: '2025-03-20', subject: 'MDD Review — Sarah Johnson', summary: 'Sarah responding well to Sertraline 50mg. PHQ-9 improved 18→8. No dose change recommended. Tolerating medication well. Continue fortnightly CBT. Review in 3 months. No concerns re: drug interactions with current diabetes/hypertension medications.' }
    ],
    transferDocuments: []
  },
  {
    id: 'CUST002',
    name: 'James Mitchell',
    dateOfBirth: '1953-11-08',
    gender: 'Male',
    phone: '+61 423 876 543',
    email: 'james.mitchell@email.com',
    address: '15 Harbour Rd, Sydney NSW 2000',
    medicareNumber: '4521 88734 1',
    concessionCard: 'Pension Card',
    ihi: '8003608444444444',
    allergies: [
      { substance: 'Aspirin', severity: 'Severe', reaction: 'Bronchospasm, anaphylaxis risk' }
    ],
    conditions: [
      { name: 'Atrial Fibrillation', diagnosedDate: '2018-05-12', status: 'Active', managedBy: 'Dr. Robert Lee' },
      { name: 'Chronic Kidney Disease Stage 3', diagnosedDate: '2021-09-01', status: 'Active', managedBy: 'Dr. Robert Lee' },
      { name: 'Osteoarthritis', diagnosedDate: '2015-03-20', status: 'Active', managedBy: 'Dr. Amanda White' }
    ],
    prescriptions: [
      {
        id: 'RX004',
        medication: 'Metoprolol 50mg',
        doctor: 'Dr. Robert Lee',
        doctorProviderNumber: '2460234A',
        clinic: 'Sydney Heart Clinic',
        issued: '2025-12-10',
        expires: '2026-09-10',
        refillsRemaining: 2,
        totalRefills: 5,
        status: 'Active',
        isRepeat: true,
        lastFilledDate: '2026-02-10',
        pbs: true,
        pbsItemCode: '02150K',
        pbsAuthority: false,
        streamlinedAuth: false,
        brandOptions: ['Betaloc', 'Minax', 'Metrol'],
        dispensedBrand: 'Betaloc',
        erxScriptToken: 'ERXT-2025-004-MET',
        erxScriptType: 'eRx',
        erxBarcodeRef: '93310002345678',
        dosageInstructions: '1 tablet twice daily',
        quantityPrescribed: 60,
        quantityDispensed: 60,
        conditionTreated: 'Atrial Fibrillation',
        safetyNetContribution: 6.80,
        concessionApplied: true,
        notes: 'Heart rate well controlled at 62 bpm.'
      },
      {
        id: 'RX005',
        medication: 'Rosuvastatin 10mg',
        doctor: 'Dr. Robert Lee',
        doctorProviderNumber: '2460234A',
        clinic: 'Sydney Heart Clinic',
        issued: '2025-11-20',
        expires: '2026-08-20',
        refillsRemaining: 1,
        totalRefills: 3,
        status: 'Active',
        isRepeat: true,
        lastFilledDate: '2026-01-14',
        pbs: true,
        pbsItemCode: '09219L',
        pbsAuthority: false,
        streamlinedAuth: true,
        brandOptions: ['Crestor', 'Rosuvas', 'Rostor'],
        dispensedBrand: 'Crestor',
        erxScriptToken: 'ERXT-2025-005-ROS',
        erxScriptType: 'eRx',
        erxBarcodeRef: '93310002345679',
        dosageInstructions: '1 tablet daily in the evening',
        quantityPrescribed: 30,
        quantityDispensed: 30,
        conditionTreated: 'Hyperlipidemia',
        safetyNetContribution: 6.80,
        concessionApplied: true,
        notes: 'Cholesterol improving. Continue current dose.'
      }
    ],
    pbsSafetyNet: {
      currentSpend: 1520.00,
      threshold: 1694.00,
      scriptsThisYear: 22,
      safetyNetReached: false
    },
    dispensingHistory: [
      { medication: 'Metoprolol 50mg', date: '2025-07-01', quantity: 60, pbsCost: 6.80, dispensedBy: 'Alex Pharmacist' },
      { medication: 'Rosuvastatin 10mg', date: '2025-06-25', quantity: 30, pbsCost: 6.80, dispensedBy: 'Alex Pharmacist' },
      { medication: 'Metoprolol 50mg', date: '2025-06-01', quantity: 60, pbsCost: 6.80, dispensedBy: 'Alex Pharmacist' }
    ],
    consent: { myHealthRecord: true, pbsClaiming: true, marketingComms: false },
    notes: 'Elderly patient. Uses Webster-pak. Monitor renal function closely. Near PBS safety net threshold.',
    immunisations: [
      { name: 'COVID-19 (Pfizer)', date: '2024-03-10', status: 'Completed' },
      { name: 'Influenza', date: '2025-03-15', status: 'Completed' },
      { name: 'Shingrix (Shingles)', date: '2024-08-20', status: 'Completed' }
    ],
    pathologyResults: [
      { test: 'eGFR', result: '42 mL/min', date: '2025-06-15', referenceRange: '> 60', status: 'Below Normal' },
      { test: 'INR', result: '2.3', date: '2025-06-15', referenceRange: '2.0-3.0', status: 'Normal' },
      { test: 'Total Cholesterol', result: '4.8 mmol/L', date: '2025-06-15', referenceRange: '< 5.5', status: 'Normal' },
      { test: 'Potassium', result: '5.0 mmol/L', date: '2025-06-15', referenceRange: '3.5-5.2', status: 'Normal' }
    ],
    sharedHealthSummary: {
      lastUpdated: '2025-06-15',
      author: 'Dr. Robert Lee',
      clinic: 'Sydney Heart Clinic',
      summary: 'Elderly gentleman (72). Atrial fibrillation on Metoprolol. CKD Stage 3 (eGFR 42 — declining). Osteoarthritis. Severe aspirin allergy (anaphylaxis risk). Pension card holder. Near PBS safety net threshold. Uses Webster-pak.'
    },
    adverseReactions: [
      { substance: 'Aspirin', reaction: 'Bronchospasm and near-anaphylaxis requiring adrenaline', date: '2012-04-20', severity: 'Severe', reporter: 'Emergency Department — Royal North Shore', status: 'Active' }
    ],
    carePlans: [
      { title: 'Chronic Disease Management Plan', date: '2025-02-15', author: 'Dr. Robert Lee', status: 'Active', reviewDate: '2025-08-15', summary: 'AF management: Metoprolol 50mg BD, target HR 60-80. CKD Stage 3: monitor eGFR quarterly, avoid nephrotoxins, dose-adjust renally cleared drugs. Osteoarthritis: paracetamol PRN (avoid NSAIDs with CKD). Aspirin allergy — use Clopidogrel if antiplatelet needed.' }
    ],
    diagnosticImaging: [
      { title: 'Transthoracic Echocardiogram', date: '2025-02-20', facility: 'Sydney Cardiac Imaging', referredBy: 'Dr. Robert Lee', findings: 'LVEF 55% (preserved). Mild left atrial dilatation consistent with AF. No significant valvular disease. No LV wall motion abnormality.', status: 'Reviewed' },
      { title: 'Chest X-Ray', date: '2025-01-10', facility: 'Royal North Shore Radiology', referredBy: 'Dr. Robert Lee', findings: 'Mild cardiomegaly. Clear lung fields. No pleural effusion. Degenerative changes thoracic spine.', status: 'Reviewed' }
    ],
    dischargeSummaries: [
      { hospital: 'Royal North Shore Hospital', admissionDate: '2018-05-08', dischargeDate: '2018-05-14', reason: 'New-onset atrial fibrillation with rapid ventricular response', summary: 'Presented with palpitations and dyspnoea. ECG confirmed AF with RVR 142 bpm. Cardioversion attempted — reverted then recurred. Rate control with Metoprolol commenced. Anticoagulation discussed — deferred given aspirin allergy complicating dual therapy. Discharged on Metoprolol 50mg BD.', followUp: 'Dr. Robert Lee — Cardiology in 2 weeks. GP follow-up for anticoagulation decision.' }
    ],
    eReferrals: [
      { from: 'Dr. Robert Lee', to: 'Renal Clinic — Royal North Shore', date: '2025-04-01', reason: 'Declining eGFR (42 mL/min) — CKD Stage 3b assessment', urgency: 'Semi-urgent', status: 'Accepted' }
    ],
    eventSummaries: [
      { title: 'Cardiology Review', date: '2025-06-10', provider: 'Dr. Robert Lee', clinic: 'Sydney Heart Clinic', summary: 'AF — rate controlled (HR 62 on Metoprolol). Echo: LVEF 55%. CKD Stage 3 (eGFR 42 — stable). Cholesterol well managed on Rosuvastatin. Continue current medications. Review renal function in 3 months.' }
    ],
    goalsOfCare: [],
    specialistLetters: [
      { from: 'Dr. Robert Lee — Cardiologist', to: 'GP', date: '2025-06-15', subject: 'AF and CKD Follow-up', summary: 'James\' AF is rate-controlled. eGFR 42 (CKD 3b). Rosuvastatin dose appropriate for renal function. Monitor potassium closely given CKD. Aspirin permanently contraindicated. Consider Apixaban if CHA2DS2-VASc warrants anticoagulation (dose-reduce for CKD).' }
    ],
    transferDocuments: []
  },
  {
    id: 'CUST003',
    name: 'Emily Chen',
    dateOfBirth: '1997-06-22',
    gender: 'Female',
    phone: '+61 498 123 456',
    email: 'emily.chen@email.com',
    address: '8/120 Lygon St, Carlton VIC 3053',
    medicareNumber: '5892 33456 7',
    concessionCard: null,
    ihi: '8003608555555555',
    allergies: [
      { substance: 'Codeine', severity: 'Moderate', reaction: 'Severe nausea, vomiting' },
      { substance: 'Latex', severity: 'Mild', reaction: 'Contact dermatitis' }
    ],
    conditions: [
      { name: 'Asthma (Moderate Persistent)', diagnosedDate: '2010-04-15', status: 'Active', managedBy: 'Dr. Lisa Wang' },
      { name: 'Allergic Rhinitis', diagnosedDate: '2012-09-01', status: 'Active', managedBy: 'Dr. Lisa Wang' }
    ],
    prescriptions: [
      {
        id: 'RX006',
        medication: 'Symbicort Turbuhaler',
        doctor: 'Dr. Lisa Wang',
        doctorProviderNumber: '2470567E',
        clinic: 'Carlton Respiratory Clinic',
        issued: '2025-12-01',
        expires: '2026-10-01',
        refillsRemaining: 4,
        totalRefills: 5,
        status: 'Active',
        isRepeat: true,
        lastFilledDate: '2026-02-01',
        pbs: true,
        pbsItemCode: '09456N',
        pbsAuthority: false,
        streamlinedAuth: true,
        brandOptions: ['Symbicort', 'DuoResp'],
        dispensedBrand: 'Symbicort',
        erxScriptToken: 'ERXT-2025-006-SYM',
        erxScriptType: 'eRx',
        erxBarcodeRef: '93310003456789',
        dosageInstructions: '2 puffs twice daily; rinse mouth after use',
        quantityPrescribed: 1,
        quantityDispensed: 1,
        conditionTreated: 'Asthma',
        safetyNetContribution: 42.49,
        concessionApplied: false,
        notes: 'Good technique. Remind to rinse mouth after use.'
      }
    ],
    pbsSafetyNet: {
      currentSpend: 285.00,
      threshold: 1694.00,
      scriptsThisYear: 5,
      safetyNetReached: false
    },
    dispensingHistory: [
      { medication: 'Symbicort Turbuhaler', date: '2025-07-10', quantity: 1, pbsCost: 42.49, dispensedBy: 'Alex Pharmacist' },
      { medication: 'Ventolin Inhaler 100mcg', date: '2025-06-20', quantity: 1, pbsCost: null, dispensedBy: 'Alex Pharmacist' }
    ],
    consent: { myHealthRecord: false, pbsClaiming: true, marketingComms: true },
    notes: 'University student. Asthma action plan on file. Check inhaler technique at each visit.',
    immunisations: [
      { name: 'COVID-19 (Pfizer)', date: '2024-05-01', status: 'Completed' },
      { name: 'Influenza', date: '2025-04-10', status: 'Completed' }
    ],
    pathologyResults: [
      { test: 'Spirometry (FEV1)', result: '82%', date: '2025-05-20', referenceRange: '> 80%', status: 'Normal' },
      { test: 'IgE Total', result: '320 IU/mL', date: '2025-05-20', referenceRange: '< 100', status: 'Elevated' }
    ],
    sharedHealthSummary: {
      lastUpdated: '2025-05-20',
      author: 'Dr. Lisa Wang',
      clinic: 'Carlton Respiratory Clinic',
      summary: 'Moderate persistent asthma — well controlled on Symbicort. Allergic rhinitis (seasonal). Known adverse reactions to Codeine (severe nausea) and Latex (dermatitis). University student. Asthma action plan current.'
    },
    adverseReactions: [
      { substance: 'Codeine', reaction: 'Severe nausea and protracted vomiting (possible poor metaboliser)', date: '2021-08-15', severity: 'Moderate', reporter: 'Dr. Lisa Wang', status: 'Active' }
    ],
    carePlans: [
      { title: 'Asthma Action Plan', date: '2025-05-20', author: 'Dr. Lisa Wang', status: 'Active', reviewDate: '2025-11-20', summary: 'Green zone: Symbicort 2 puffs BD. Yellow zone: Symbicort 2 puffs QID + Ventolin PRN. Red zone: Ventolin 6 puffs via spacer, Prednisolone 50mg, call 000. Triggers: cold air, dust, pollen, exercise. Peak flow baseline 420 L/min.' }
    ],
    diagnosticImaging: [
      { title: 'Chest X-Ray', date: '2025-01-15', facility: 'Carlton Medical Imaging', referredBy: 'Dr. Lisa Wang', findings: 'Clear lung fields bilaterally. No focal consolidation or pleural effusion. Heart size normal. No bony abnormality.', status: 'Reviewed' }
    ],
    dischargeSummaries: [],
    eReferrals: [
      { from: 'Dr. Lisa Wang', to: 'Immunology Clinic — RMH', date: '2025-03-01', reason: 'Elevated IgE (320) — assessment for specific allergen immunotherapy', urgency: 'Routine', status: 'Pending' }
    ],
    eventSummaries: [
      { title: 'Asthma Review', date: '2025-05-20', provider: 'Dr. Lisa Wang', clinic: 'Carlton Respiratory Clinic', summary: 'Asthma well controlled on Symbicort. ACQ score 0.4 (well controlled). Spirometry FEV1 82% predicted — stable. Inhaler technique reviewed — good. Asthma action plan updated. Continue current therapy.' }
    ],
    goalsOfCare: [],
    specialistLetters: [
      { from: 'Dr. Lisa Wang — Respiratory Physician', to: 'Dr. Sarah Smith — GP', date: '2025-05-25', subject: 'Asthma and Allergic Rhinitis Review', summary: 'Emily\'s asthma remains well controlled on Symbicort. FEV1 stable. Elevated IgE (320) — referred to immunology for allergen testing and possible immunotherapy. Continue current medications. Avoid Codeine-containing products.' }
    ],
    transferDocuments: []
  },
  {
    id: 'CUST004',
    name: 'Robert Thompson',
    dateOfBirth: '1965-01-30',
    gender: 'Male',
    phone: '+61 407 654 321',
    email: 'robert.thompson@email.com',
    address: '22 King William St, Adelaide SA 5000',
    medicareNumber: '6123 77890 3',
    concessionCard: 'Healthcare Card',
    ihi: '8003608666666666',
    allergies: [
      { substance: 'Metoclopramide', severity: 'Severe', reaction: 'Extrapyramidal symptoms' },
      { substance: 'Iodine contrast', severity: 'Moderate', reaction: 'Urticaria' }
    ],
    conditions: [
      { name: 'Type 2 Diabetes Mellitus', diagnosedDate: '2012-06-15', status: 'Active', managedBy: 'Dr. Sarah Smith' },
      { name: 'Essential Hypertension', diagnosedDate: '2010-03-01', status: 'Active', managedBy: 'Dr. Peter Brown' },
      { name: 'Chronic Heart Failure (NYHA II)', diagnosedDate: '2022-11-15', status: 'Active', managedBy: 'Dr. Peter Brown' },
      { name: 'Gout', diagnosedDate: '2018-07-20', status: 'Active', managedBy: 'Dr. Sarah Smith' }
    ],
    prescriptions: [
      {
        id: 'RX007',
        medication: 'Metformin 500mg',
        doctor: 'Dr. Sarah Smith',
        doctorProviderNumber: '2450123B',
        clinic: 'Melbourne Medical Centre',
        issued: '2025-12-15',
        expires: '2026-09-15',
        refillsRemaining: 3,
        totalRefills: 5,
        status: 'Active',
        isRepeat: true,
        lastFilledDate: '2026-02-12',
        pbs: true,
        pbsItemCode: '08552L',
        pbsAuthority: false,
        streamlinedAuth: true,
        brandOptions: ['Glucophage', 'Diabex', 'Diaformin'],
        dispensedBrand: 'Diabex',
        erxScriptToken: 'ERXT-2025-007-MET',
        erxScriptType: 'eRx',
        erxBarcodeRef: '93310004567890',
        dosageInstructions: '1 tablet twice daily with meals',
        quantityPrescribed: 60,
        quantityDispensed: 60,
        conditionTreated: 'Type 2 Diabetes Mellitus',
        safetyNetContribution: 6.80,
        concessionApplied: true,
        notes: 'HbA1c trending up. Consider dose increase.'
      },
      {
        id: 'RX008',
        medication: 'Lisinopril 10mg',
        doctor: 'Dr. Peter Brown',
        doctorProviderNumber: '2480345F',
        clinic: 'Adelaide Heart Centre',
        issued: '2025-12-01',
        expires: '2026-09-01',
        refillsRemaining: 2,
        totalRefills: 5,
        status: 'Active',
        isRepeat: true,
        lastFilledDate: '2026-01-20',
        pbs: true,
        pbsItemCode: '01015E',
        pbsAuthority: false,
        streamlinedAuth: false,
        brandOptions: ['Zestril', 'Prinivil', 'Lisodur'],
        dispensedBrand: 'Zestril',
        erxScriptToken: 'ERXT-2025-008-LIS',
        erxScriptType: 'eRx',
        erxBarcodeRef: '93310004567891',
        dosageInstructions: '1 tablet daily in the morning',
        quantityPrescribed: 30,
        quantityDispensed: 30,
        conditionTreated: 'Essential Hypertension / CHF',
        safetyNetContribution: 6.80,
        concessionApplied: true,
        notes: 'Monitor potassium and renal function.'
      },
      {
        id: 'RX009',
        medication: 'Atorvastatin 20mg',
        doctor: 'Dr. Peter Brown',
        doctorProviderNumber: '2480345F',
        clinic: 'Adelaide Heart Centre',
        issued: '2025-11-20',
        expires: '2026-08-20',
        refillsRemaining: 1,
        totalRefills: 3,
        status: 'Active',
        isRepeat: true,
        lastFilledDate: '2026-02-01',
        pbs: true,
        pbsItemCode: '08729G',
        pbsAuthority: false,
        streamlinedAuth: true,
        brandOptions: ['Lipitor', 'Atorvast', 'Trovas'],
        dispensedBrand: 'Lipitor',
        erxScriptToken: 'ERXT-2025-009-ATO',
        erxScriptType: 'eRx',
        erxBarcodeRef: '93310004567892',
        dosageInstructions: '1 tablet daily in the evening',
        quantityPrescribed: 30,
        quantityDispensed: 30,
        conditionTreated: 'Hyperlipidemia',
        safetyNetContribution: 6.80,
        concessionApplied: true,
        notes: 'Patient reports occasional muscle aches. Monitor CK levels.'
      },
      {
        id: 'RX010',
        medication: 'Gliclazide 80mg',
        doctor: 'Dr. Sarah Smith',
        doctorProviderNumber: '2450123B',
        clinic: 'Melbourne Medical Centre',
        issued: '2026-01-01',
        expires: '2026-10-01',
        refillsRemaining: 4,
        totalRefills: 5,
        status: 'Active',
        isRepeat: true,
        lastFilledDate: '2026-01-10',
        pbs: true,
        pbsItemCode: '01820W',
        pbsAuthority: false,
        streamlinedAuth: true,
        brandOptions: ['Diamicron', 'Glyade', 'Nidem'],
        dispensedBrand: 'Diamicron',
        erxScriptToken: 'ERXT-2025-010-GLI',
        erxScriptType: 'eRx',
        erxBarcodeRef: '93310004567893',
        dosageInstructions: '1 tablet daily with breakfast',
        quantityPrescribed: 30,
        quantityDispensed: 30,
        conditionTreated: 'Type 2 Diabetes Mellitus',
        safetyNetContribution: 6.80,
        concessionApplied: true,
        notes: 'Added to regimen. Counsel on hypoglycemia signs.'
      }
    ],
    pbsSafetyNet: {
      currentSpend: 1200.00,
      threshold: 1694.00,
      scriptsThisYear: 18,
      safetyNetReached: false
    },
    dispensingHistory: [
      { medication: 'Metformin 500mg', date: '2025-07-01', quantity: 60, pbsCost: 6.80, dispensedBy: 'Alex Pharmacist' },
      { medication: 'Lisinopril 10mg', date: '2025-07-05', quantity: 30, pbsCost: 6.80, dispensedBy: 'Alex Pharmacist' },
      { medication: 'Gliclazide 80mg', date: '2025-07-08', quantity: 30, pbsCost: 6.80, dispensedBy: 'Alex Pharmacist' },
      { medication: 'Atorvastatin 20mg', date: '2025-06-20', quantity: 30, pbsCost: 6.80, dispensedBy: 'Alex Pharmacist' }
    ],
    consent: { myHealthRecord: true, pbsClaiming: true, marketingComms: false },
    notes: 'Complex poly-pharmacy. Drug interaction monitoring required (Metformin + Gliclazide hypo risk). Renal function declining — dose adjustments may be needed.',
    immunisations: [
      { name: 'COVID-19 (Pfizer)', date: '2024-04-20', status: 'Completed' },
      { name: 'Influenza', date: '2025-03-20', status: 'Completed' }
    ],
    pathologyResults: [
      { test: 'HbA1c', result: '8.1%', date: '2025-06-20', referenceRange: '< 7.0%', status: 'Elevated' },
      { test: 'eGFR', result: '55 mL/min', date: '2025-06-20', referenceRange: '> 60', status: 'Below Normal' },
      { test: 'BNP', result: '280 pg/mL', date: '2025-06-20', referenceRange: '< 100', status: 'Elevated' },
      { test: 'Potassium', result: '5.1 mmol/L', date: '2025-06-20', referenceRange: '3.5-5.2', status: 'Normal' },
      { test: 'CK (Creatine Kinase)', result: '195 U/L', date: '2025-06-20', referenceRange: '< 200', status: 'Normal' }
    ],
    sharedHealthSummary: {
      lastUpdated: '2025-06-20',
      author: 'Dr. Sarah Smith',
      clinic: 'Melbourne Medical Centre',
      summary: 'Complex poly-pharmacy patient. T2DM (HbA1c 8.1% — above target, dual therapy Metformin + Gliclazide). Hypertension and CHF (NYHA II) on Lisinopril. Hyperlipidemia on Atorvastatin (monitoring CK for myalgia). Gout — allopurinol PRN. Declining renal function (eGFR 55). Multiple drug interaction risks.'
    },
    adverseReactions: [
      { substance: 'Metoclopramide', reaction: 'Acute dystonic reaction — torticollis and oculogyric crisis', date: '2019-11-05', severity: 'Severe', reporter: 'Emergency Department — RAH', status: 'Active' }
    ],
    carePlans: [
      { title: 'Heart Failure Management Plan', date: '2025-03-01', author: 'Dr. Peter Brown', status: 'Active', reviewDate: '2025-09-01', summary: 'NYHA Class II. Lisinopril 10mg daily. Fluid restriction 1.5L/day. Daily weights. Low sodium diet. BNP monitoring 3-monthly. Echocardiogram annually. Escalation plan if symptoms worsen.' },
      { title: 'Diabetes Management Plan', date: '2025-01-15', author: 'Dr. Sarah Smith', status: 'Active', reviewDate: '2025-07-15', summary: 'HbA1c 8.1% — above target. Dual therapy: Metformin 500mg BD + Gliclazide 80mg mane. Counsel on hypoglycemia. Consider third agent or insulin if no improvement in 3 months. Renal function declining — dose adjustments may be needed.' }
    ],
    diagnosticImaging: [
      { title: 'Transthoracic Echocardiogram', date: '2025-03-15', facility: 'Adelaide Heart Imaging', referredBy: 'Dr. Peter Brown', findings: 'LVEF 42% (mildly reduced). Mild LV dilatation. Grade I diastolic dysfunction. No significant valvular disease. No pericardial effusion.', status: 'Reviewed' },
      { title: 'Renal Ultrasound', date: '2025-04-10', facility: 'Adelaide Medical Imaging', referredBy: 'Dr. Sarah Smith', findings: 'Kidneys normal in size (R: 10.8cm, L: 11.0cm). No hydronephrosis. No renal calculi. Increased cortical echogenicity bilaterally consistent with medical renal disease.', status: 'Reviewed' }
    ],
    dischargeSummaries: [
      { hospital: 'Royal Adelaide Hospital', admissionDate: '2022-11-10', dischargeDate: '2022-11-17', reason: 'Acute decompensated heart failure — first presentation', summary: 'Presented with dyspnoea and peripheral oedema. BNP elevated at 850 pg/mL. Echo showed LVEF 40%. Managed with IV Frusemide and commenced on Lisinopril. Stabilised and discharged with heart failure education. Referred to cardiac rehabilitation.', followUp: 'Dr. Peter Brown in 1 week. Cardiac rehab referral. Repeat echo in 3 months.' }
    ],
    eReferrals: [
      { from: 'Dr. Sarah Smith', to: 'Dr. Peter Brown — Cardiologist', date: '2022-11-20', reason: 'Ongoing management of newly diagnosed CHF (NYHA II)', urgency: 'Semi-urgent', status: 'Accepted' },
      { from: 'Dr. Sarah Smith', to: 'Renal Clinic — RAH', date: '2025-05-01', reason: 'Declining eGFR (55 mL/min) — CKD assessment and management', urgency: 'Routine', status: 'Pending' }
    ],
    eventSummaries: [
      { title: 'Cardiology Review', date: '2025-06-10', provider: 'Dr. Peter Brown', clinic: 'Adelaide Heart Centre', summary: 'NYHA II — stable. No hospitalisations since 2022. BP 132/80. BNP 280 (stable). Echo shows LVEF 42% (stable). Continue current medications. Review in 6 months.' },
      { title: 'Diabetes Review', date: '2025-06-20', provider: 'Dr. Sarah Smith', clinic: 'Melbourne Medical Centre', summary: 'HbA1c 8.1% — worsening. Added Gliclazide 80mg. eGFR declining — renal referral made. CK normal (195 — ruling out statin myopathy). Review in 3 months.' }
    ],
    goalsOfCare: [
      { title: 'Chronic Disease Goals', date: '2025-01-15', author: 'Dr. Sarah Smith', goals: ['Reduce HbA1c to <7.5% within 6 months', 'Maintain NYHA Class II or better', 'Preserve renal function (eGFR target >45)', 'Minimise polypharmacy interactions'], status: 'Active' }
    ],
    specialistLetters: [
      { from: 'Dr. Peter Brown — Cardiologist', to: 'Dr. Sarah Smith — GP', date: '2025-06-15', subject: 'Heart Failure Review', summary: 'Robert remains NYHA II. LVEF stable at 42%. BNP trending stable. Current medication regimen appropriate. No changes recommended. Monitor renal function given ACE inhibitor use and declining eGFR. Consider cardio-renal syndrome if further decline.' }
    ],
    transferDocuments: []
  },
  {
    id: 'CUST005',
    name: 'Maria Garcia',
    dateOfBirth: '1992-09-14',
    gender: 'Female',
    phone: '+61 434 567 890',
    email: 'maria.garcia@email.com',
    address: '5/88 Brunswick St, Fitzroy VIC 3065',
    medicareNumber: '7234 55678 4',
    concessionCard: null,
    ihi: '8003608777777777',
    allergies: [],
    conditions: [
      { name: 'Pregnancy (28 weeks)', diagnosedDate: '2025-01-15', status: 'Active', managedBy: 'Dr. Helen Park' },
      { name: 'Gestational Diabetes', diagnosedDate: '2025-05-20', status: 'Active', managedBy: 'Dr. Helen Park' },
      { name: 'Iron Deficiency Anaemia', diagnosedDate: '2025-03-10', status: 'Active', managedBy: 'Dr. Helen Park' }
    ],
    prescriptions: [
      {
        id: 'RX011',
        medication: 'Insulin Glargine',
        doctor: 'Dr. Helen Park',
        doctorProviderNumber: '2490678G',
        clinic: 'Fitzroy Maternity Clinic',
        issued: '2025-12-01',
        expires: '2026-09-01',
        refillsRemaining: 3,
        totalRefills: 5,
        status: 'Active',
        isRepeat: true,
        lastFilledDate: '2026-02-08',
        pbs: true,
        pbsItemCode: '03075J',
        pbsAuthority: true,
        streamlinedAuth: false,
        brandOptions: ['Lantus', 'Optisulin'],
        dispensedBrand: 'Lantus',
        erxScriptToken: 'ERXT-2025-011-INS',
        erxScriptType: 'eRx',
        erxBarcodeRef: '93310005678901',
        dosageInstructions: '10 units at bedtime; titrate per BSL',
        quantityPrescribed: 1,
        quantityDispensed: 1,
        conditionTreated: 'Gestational Diabetes',
        safetyNetContribution: 42.49,
        concessionApplied: false,
        pregnancyCategory: 'B3',
        notes: 'Pregnancy Category B3. Monitor BSL closely. Adjust dose weekly.'
      },
      {
        id: 'RX012',
        medication: 'Ferrous Sulfate 325mg',
        doctor: 'Dr. Helen Park',
        doctorProviderNumber: '2490678G',
        clinic: 'Fitzroy Maternity Clinic',
        issued: '2025-12-15',
        expires: '2026-09-15',
        refillsRemaining: 2,
        totalRefills: 5,
        status: 'Active',
        isRepeat: true,
        lastFilledDate: '2026-01-22',
        pbs: true,
        pbsItemCode: '02345K',
        pbsAuthority: false,
        streamlinedAuth: false,
        brandOptions: ['Ferro-Gradumet', 'FGF', 'Ferrograd'],
        dispensedBrand: 'Ferro-Gradumet',
        erxScriptToken: 'ERXT-2025-012-FER',
        erxScriptType: 'eRx',
        erxBarcodeRef: '93310005678902',
        dosageInstructions: '1 tablet daily on an empty stomach with vitamin C',
        quantityPrescribed: 30,
        quantityDispensed: 30,
        conditionTreated: 'Iron Deficiency Anaemia',
        safetyNetContribution: 6.80,
        concessionApplied: false,
        pregnancyCategory: 'A',
        notes: 'Safe in pregnancy. Counsel on constipation and black stools.'
      }
    ],
    pbsSafetyNet: {
      currentSpend: 180.00,
      threshold: 1694.00,
      scriptsThisYear: 4,
      safetyNetReached: false
    },
    dispensingHistory: [
      { medication: 'Insulin Glargine', date: '2025-07-05', quantity: 1, pbsCost: 42.49, dispensedBy: 'Alex Pharmacist' },
      { medication: 'Ferrous Sulfate 325mg', date: '2025-06-15', quantity: 30, pbsCost: 6.80, dispensedBy: 'Alex Pharmacist' }
    ],
    consent: { myHealthRecord: true, pbsClaiming: true, marketingComms: false },
    notes: 'Pregnant patient (28 weeks). All medications must be pregnancy-safe. Check category before dispensing. Due date: August 2025.',
    immunisations: [
      { name: 'COVID-19 (Pfizer)', date: '2024-06-01', status: 'Completed' },
      { name: 'Influenza', date: '2025-04-15', status: 'Completed' },
      { name: 'Pertussis (Boostrix)', date: '2025-06-01', status: 'Completed' }
    ],
    pathologyResults: [
      { test: 'HbA1c', result: '6.2%', date: '2025-06-01', referenceRange: '< 6.5%', status: 'Normal' },
      { test: 'Iron Studies (Ferritin)', result: '18 ug/L', date: '2025-06-01', referenceRange: '20-200', status: 'Below Normal' },
      { test: 'Haemoglobin', result: '105 g/L', date: '2025-06-01', referenceRange: '115-165', status: 'Below Normal' },
      { test: 'Glucose (Fasting)', result: '5.8 mmol/L', date: '2025-06-01', referenceRange: '< 5.5', status: 'Slightly Elevated' }
    ],
    sharedHealthSummary: {
      lastUpdated: '2025-06-01',
      author: 'Dr. Helen Park',
      clinic: 'Fitzroy Maternity Clinic',
      summary: 'G1P0 at 28 weeks gestation. Gestational diabetes managed with Insulin Glargine. Iron deficiency anaemia on Ferrous Sulfate. No known allergies. All medications pregnancy-safe. Due date estimated August 2025.'
    },
    adverseReactions: [],
    carePlans: [
      { title: 'Antenatal Care Plan', date: '2025-02-01', author: 'Dr. Helen Park', status: 'Active', reviewDate: '2025-08-01', summary: 'Fortnightly antenatal visits. GDM monitoring — BSL QID. Insulin Glargine 10 units nocte (titrate weekly). Iron supplementation. Pertussis vaccination completed. Anomaly scan completed — normal. Planned delivery at Royal Women\'s Hospital.' },
      { title: 'Gestational Diabetes Management Plan', date: '2025-05-25', author: 'Dr. Helen Park', status: 'Active', reviewDate: '2025-08-01', summary: 'Diet-controlled initially, commenced Insulin Glargine at 24 weeks due to rising fasting BSLs. Target fasting <5.0, 2hr post-prandial <6.7. Diabetes educator fortnightly. Postpartum OGTT planned at 6 weeks.' }
    ],
    diagnosticImaging: [
      { title: 'Obstetric Ultrasound — Morphology Scan', date: '2025-04-10', facility: 'Melbourne Ultrasound for Women', referredBy: 'Dr. Helen Park', findings: 'Single live intrauterine pregnancy. Fetal biometry consistent with 20 weeks. Normal anatomy survey. Anterior placenta, clear of os. AFI normal. EFW 350g (50th percentile).', status: 'Reviewed' },
      { title: 'Obstetric Ultrasound — Growth Scan', date: '2025-06-20', facility: 'Melbourne Ultrasound for Women', referredBy: 'Dr. Helen Park', findings: 'Growth appropriate for gestational age (28 weeks). EFW 1150g (55th percentile). Normal amniotic fluid. Placenta clear of cervix. Fetal movements present.', status: 'Reviewed' }
    ],
    dischargeSummaries: [],
    eReferrals: [
      { from: 'Dr. Helen Park', to: 'Diabetes Educator — Jane Williams', date: '2025-05-25', reason: 'GDM education — insulin initiation, BSL monitoring, dietary guidance', urgency: 'Semi-urgent', status: 'Completed' },
      { from: 'Dr. Helen Park', to: 'Royal Women\'s Hospital — Obstetric Unit', date: '2025-06-15', reason: 'Hospital booking for planned delivery — GDM, insulin-requiring', urgency: 'Routine', status: 'Accepted' }
    ],
    eventSummaries: [
      { title: 'Antenatal Visit — 28 Weeks', date: '2025-06-20', provider: 'Dr. Helen Park', clinic: 'Fitzroy Maternity Clinic', summary: 'BP 118/72. Fundal height appropriate. Fetal movements normal. BSLs generally well controlled on Insulin Glargine 10 units. Ferritin improving (18 → expected improvement with supplementation). Pertussis vaccine given. Growth scan normal.' }
    ],
    goalsOfCare: [],
    specialistLetters: [],
    transferDocuments: []
  },
  {
    id: 'CUST006',
    name: 'David Kim',
    dateOfBirth: '1988-12-03',
    gender: 'Male',
    phone: '+61 445 234 567',
    email: 'david.kim@email.com',
    address: '302/55 City Rd, Southbank VIC 3006',
    medicareNumber: '8345 22109 5',
    concessionCard: 'Healthcare Card',
    ihi: '8003608888888888',
    allergies: [
      { substance: 'Tramadol', severity: 'Moderate', reaction: 'Seizures' }
    ],
    conditions: [
      { name: 'Bipolar Disorder Type II', diagnosedDate: '2016-08-15', status: 'Active', managedBy: 'Dr. Mark Taylor' },
      { name: 'Generalised Anxiety Disorder', diagnosedDate: '2015-03-01', status: 'Active', managedBy: 'Dr. Mark Taylor' },
      { name: 'Insomnia', diagnosedDate: '2020-11-10', status: 'Active', managedBy: 'Dr. Mark Taylor' }
    ],
    prescriptions: [
      {
        id: 'RX013',
        medication: 'Escitalopram 10mg',
        doctor: 'Dr. Mark Taylor',
        doctorProviderNumber: '2500890H',
        clinic: 'Southbank Mental Health',
        issued: '2025-12-20',
        expires: '2026-09-20',
        refillsRemaining: 3,
        totalRefills: 5,
        status: 'Active',
        isRepeat: true,
        lastFilledDate: '2026-02-10',
        pbs: true,
        pbsItemCode: '09876P',
        pbsAuthority: false,
        streamlinedAuth: true,
        brandOptions: ['Lexapro', 'Esipram', 'Loxalate'],
        dispensedBrand: 'Lexapro',
        erxScriptToken: 'ERXT-2025-013-ESC',
        erxScriptType: 'eRx',
        erxBarcodeRef: '93310006789012',
        dosageInstructions: '1 tablet daily in the morning',
        quantityPrescribed: 30,
        quantityDispensed: 30,
        conditionTreated: 'GAD / Bipolar Depression',
        safetyNetContribution: 6.80,
        concessionApplied: true,
        notes: 'Stable on current dose. Monitor for hypomania.'
      },
      {
        id: 'RX014',
        medication: 'Sodium Valproate 500mg',
        doctor: 'Dr. Mark Taylor',
        doctorProviderNumber: '2500890H',
        clinic: 'Southbank Mental Health',
        issued: '2025-12-01',
        expires: '2026-09-01',
        refillsRemaining: 2,
        totalRefills: 5,
        status: 'Active',
        isRepeat: true,
        lastFilledDate: '2026-02-05',
        pbs: true,
        pbsItemCode: '01560E',
        pbsAuthority: true,
        streamlinedAuth: false,
        brandOptions: ['Epilim', 'Valpro', 'Valproate Sandoz'],
        dispensedBrand: 'Epilim',
        erxScriptToken: 'ERXT-2025-014-VAL',
        erxScriptType: 'eRx',
        erxBarcodeRef: '93310006789013',
        dosageInstructions: '1 tablet twice daily with food',
        quantityPrescribed: 60,
        quantityDispensed: 60,
        conditionTreated: 'Bipolar Disorder (Mood Stabiliser)',
        safetyNetContribution: 6.80,
        concessionApplied: true,
        authorityPrescriptionNumber: 'AUTH-2025-3456',
        notes: 'Authority prescription. Therapeutic level monitoring required.'
      },
      {
        id: 'RX015',
        medication: 'Melatonin 2mg',
        doctor: 'Dr. Mark Taylor',
        doctorProviderNumber: '2500890H',
        clinic: 'Southbank Mental Health',
        issued: '2026-01-01',
        expires: '2026-10-01',
        refillsRemaining: 4,
        totalRefills: 5,
        status: 'Active',
        isRepeat: true,
        lastFilledDate: '2026-01-12',
        pbs: true,
        pbsItemCode: '10234Q',
        pbsAuthority: false,
        streamlinedAuth: true,
        brandOptions: ['Circadin', 'Melatonin Compounded'],
        dispensedBrand: 'Circadin',
        erxScriptToken: 'ERXT-2025-015-MEL',
        erxScriptType: 'eRx',
        erxBarcodeRef: '93310006789014',
        dosageInstructions: '1 tablet 1-2 hours before bedtime',
        quantityPrescribed: 30,
        quantityDispensed: 30,
        conditionTreated: 'Insomnia',
        safetyNetContribution: 6.80,
        concessionApplied: true,
        notes: 'Preferred over benzodiazepines. Sleep hygiene counselling given.'
      }
    ],
    pbsSafetyNet: {
      currentSpend: 640.00,
      threshold: 1694.00,
      scriptsThisYear: 10,
      safetyNetReached: false
    },
    dispensingHistory: [
      { medication: 'Escitalopram 10mg', date: '2025-07-10', quantity: 30, pbsCost: 6.80, dispensedBy: 'Alex Pharmacist' },
      { medication: 'Sodium Valproate 500mg', date: '2025-07-01', quantity: 60, pbsCost: 6.80, dispensedBy: 'Alex Pharmacist' },
      { medication: 'Melatonin 2mg', date: '2025-07-10', quantity: 30, pbsCost: 6.80, dispensedBy: 'Alex Pharmacist' }
    ],
    consent: { myHealthRecord: true, pbsClaiming: true, marketingComms: false },
    notes: 'Mental health patient. Requires sensitive counselling. Authority scripts for valproate. Check therapeutic drug levels.',
    immunisations: [
      { name: 'COVID-19 (Pfizer)', date: '2024-05-15', status: 'Completed' },
      { name: 'Influenza', date: '2025-04-05', status: 'Completed' }
    ],
    pathologyResults: [
      { test: 'Valproate Level', result: '75 mg/L', date: '2025-06-15', referenceRange: '50-100', status: 'Normal' },
      { test: 'Liver Function (ALT)', result: '35 U/L', date: '2025-06-15', referenceRange: '< 40', status: 'Normal' },
      { test: 'Full Blood Count', result: 'Normal', date: '2025-06-15', referenceRange: 'Normal ranges', status: 'Normal' }
    ],
    sharedHealthSummary: {
      lastUpdated: '2025-06-15',
      author: 'Dr. Mark Taylor',
      clinic: 'Southbank Mental Health',
      summary: 'Bipolar II disorder — stable on Sodium Valproate and Escitalopram. GAD managed. Insomnia treated with Melatonin. Adverse reaction to Tramadol (seizures) documented. Therapeutic drug monitoring current. No suicidal ideation.'
    },
    adverseReactions: [
      { substance: 'Tramadol', reaction: 'Generalised tonic-clonic seizure — likely serotonin syndrome interaction', date: '2020-03-10', severity: 'Severe', reporter: 'Emergency Department — Alfred Hospital', status: 'Active' }
    ],
    carePlans: [
      { title: 'Mental Health Treatment Plan', date: '2025-04-01', author: 'Dr. Mark Taylor', status: 'Active', reviewDate: '2025-10-01', summary: 'Sodium Valproate 500mg BD (authority). Escitalopram 10mg daily. Melatonin 2mg nocte. Fortnightly psychology. Crisis plan documented. Therapeutic drug levels 3-monthly. Avoid serotonergic medications.' }
    ],
    diagnosticImaging: [],
    dischargeSummaries: [
      { hospital: 'Alfred Hospital', admissionDate: '2020-03-10', dischargeDate: '2020-03-14', reason: 'Seizure secondary to suspected serotonin syndrome (Tramadol + SSRI interaction)', summary: 'Presented with generalised seizure after GP prescribed Tramadol for back pain while on Escitalopram. CT brain normal. EEG no epileptiform activity. Tramadol ceased permanently. Discharged stable on existing psychiatric medications.', followUp: 'Dr. Mark Taylor in 1 week. GP review for alternative analgesics.' }
    ],
    eReferrals: [
      { from: 'Dr. Mark Taylor', to: 'Clinical Psychologist — Dr. Anna Lee', date: '2025-01-15', reason: 'CBT for anxiety management and mood stability', urgency: 'Routine', status: 'Accepted' }
    ],
    eventSummaries: [
      { title: 'Psychiatric Review', date: '2025-06-15', provider: 'Dr. Mark Taylor', clinic: 'Southbank Mental Health', summary: 'Mood stable. No manic/hypomanic episodes in 8 months. Valproate level therapeutic (75 mg/L). Sleep improved with Melatonin. PHQ-9: 6 (mild). GAD-7: 8 (mild). Continue current regimen.' }
    ],
    goalsOfCare: [],
    specialistLetters: [
      { from: 'Dr. Mark Taylor — Psychiatrist', to: 'Dr. Sarah Smith — GP', date: '2025-06-20', subject: 'Bipolar II and GAD — Ongoing Management', summary: 'David remains stable on current regimen. Valproate therapeutic. No dose changes recommended. Authority prescription renewed for 6 months. Please continue 3-monthly LFTs and FBC. CRITICAL: No Tramadol or other serotonergic analgesics — seizure history.' }
    ],
    transferDocuments: []
  },
  {
    id: 'CUST007',
    name: 'Linda Brown',
    dateOfBirth: '1985-04-18',
    gender: 'Female',
    phone: '+61 456 789 012',
    email: 'linda.brown@email.com',
    address: '7 Acacia Ave, Hawthorn VIC 3122',
    medicareNumber: '9456 88234 6',
    concessionCard: null,
    ihi: '8003608999999999',
    allergies: [],
    conditions: [
      { name: 'ADHD (Child - collecting for son Liam, age 8)', diagnosedDate: '2024-02-15', status: 'Active', managedBy: 'Dr. Rachel Green' }
    ],
    prescriptions: [
      {
        id: 'RX016',
        medication: 'Methylphenidate 10mg',
        doctor: 'Dr. Rachel Green',
        doctorProviderNumber: '2510456J',
        clinic: 'Hawthorn Paediatrics',
        issued: '2026-01-15',
        expires: '2026-08-01',
        refillsRemaining: 1,
        totalRefills: 1,
        status: 'Active',
        isRepeat: false,
        lastFilledDate: null,
        pbs: true,
        pbsItemCode: '05678M',
        pbsAuthority: true,
        streamlinedAuth: false,
        brandOptions: ['Ritalin 10', 'Concerta'],
        dispensedBrand: null,
        erxScriptToken: 'ERXT-2025-016-MPH',
        erxScriptType: 'eRx',
        erxBarcodeRef: '93310007890123',
        dosageInstructions: '1 tablet in the morning before school',
        quantityPrescribed: 30,
        quantityDispensed: 0,
        conditionTreated: 'ADHD',
        safetyNetContribution: 42.49,
        concessionApplied: false,
        isControlledSubstance: true,
        schedule: 'S8',
        patientName: 'Liam Brown',
        patientDOB: '2017-08-22',
        authorityPrescriptionNumber: 'AUTH-2025-7890',
        notes: 'S8 Controlled substance. Verify ID. Record in S8 register. Monthly script only, no repeats.'
      }
    ],
    pbsSafetyNet: {
      currentSpend: 120.00,
      threshold: 1694.00,
      scriptsThisYear: 2,
      safetyNetReached: false
    },
    dispensingHistory: [
      { medication: 'Methylphenidate 10mg', date: '2025-06-05', quantity: 30, pbsCost: 42.49, dispensedBy: 'Alex Pharmacist' }
    ],
    consent: { myHealthRecord: true, pbsClaiming: true, marketingComms: true },
    notes: 'Collecting S8 for son Liam (8yo). Must verify photo ID. Record in controlled drugs register. Script cannot be repeated — new script each month.',
    immunisations: [],
    pathologyResults: [],
    sharedHealthSummary: null,
    adverseReactions: [],
    carePlans: [
      { title: 'ADHD Management Plan (Liam Brown)', date: '2025-02-15', author: 'Dr. Rachel Green', status: 'Active', reviewDate: '2025-08-15', summary: 'Methylphenidate 10mg morning on school days. Behavioural therapy fortnightly. Teacher liaison. Monthly weight and height check. School performance monitoring. S8 prescriptions — monthly supply only, no repeats.' }
    ],
    diagnosticImaging: [],
    dischargeSummaries: [],
    eReferrals: [
      { from: 'Dr. Rachel Green', to: 'Child Psychology Services — Dr. Karen White', date: '2024-12-01', reason: 'Behavioural therapy and cognitive assessment for ADHD management', urgency: 'Routine', status: 'Accepted' }
    ],
    eventSummaries: [
      { title: 'Paediatric ADHD Review (Liam Brown)', date: '2025-06-15', provider: 'Dr. Rachel Green', clinic: 'Hawthorn Paediatrics', summary: 'Liam responding well to Methylphenidate 10mg. Weight 26kg (25th percentile — stable). Height tracking normally. School reports improved concentration. Continue current dose. Review in 3 months.' }
    ],
    goalsOfCare: [],
    specialistLetters: [
      { from: 'Dr. Rachel Green — Paediatrician', to: 'Hawthorn Primary School', date: '2025-03-01', subject: 'ADHD Diagnosis and Management — Liam Brown', summary: 'Liam has been diagnosed with ADHD and commenced on Methylphenidate. Recommend preferential seating, task chunking, movement breaks, and regular teacher feedback to parents.' }
    ],
    transferDocuments: []
  },
  {
    id: 'CUST008',
    name: "Michael O'Brien",
    dateOfBirth: '1945-07-25',
    gender: 'Male',
    phone: '+61 467 890 123',
    email: null,
    address: 'Room 12, Sunshine Aged Care, 45 Garden Rd, Toorak VIC 3142',
    medicareNumber: '1567 44321 8',
    concessionCard: 'Pension Card',
    ihi: '8003609111111111',
    allergies: [
      { substance: 'NSAIDs', severity: 'Severe', reaction: 'GI bleeding' },
      { substance: 'ACE Inhibitors', severity: 'Moderate', reaction: 'Angioedema' }
    ],
    conditions: [
      { name: 'Alzheimer\'s Disease (Moderate)', diagnosedDate: '2022-03-15', status: 'Active', managedBy: 'Dr. James Wong' },
      { name: 'Essential Hypertension', diagnosedDate: '2005-06-01', status: 'Active', managedBy: 'Dr. James Wong' },
      { name: 'Osteoporosis', diagnosedDate: '2019-11-10', status: 'Active', managedBy: 'Dr. James Wong' },
      { name: 'Benign Prostatic Hyperplasia', diagnosedDate: '2017-04-20', status: 'Active', managedBy: 'Dr. James Wong' }
    ],
    prescriptions: [
      {
        id: 'RX017',
        medication: 'Amlodipine 5mg',
        doctor: 'Dr. James Wong',
        doctorProviderNumber: '2520567K',
        clinic: 'Toorak Medical Practice',
        issued: '2025-12-01',
        expires: '2026-09-01',
        refillsRemaining: 2,
        totalRefills: 5,
        status: 'Active',
        isRepeat: true,
        lastFilledDate: '2026-02-03',
        pbs: true,
        pbsItemCode: '08234F',
        pbsAuthority: false,
        streamlinedAuth: false,
        brandOptions: ['Norvasc', 'Nordip', 'Amlod'],
        dispensedBrand: 'Norvasc',
        erxScriptToken: 'ERXT-2025-017-AML',
        erxScriptType: 'eRx',
        erxBarcodeRef: '93310008901234',
        dosageInstructions: '1 tablet daily in the morning',
        quantityPrescribed: 30,
        quantityDispensed: 30,
        conditionTreated: 'Essential Hypertension',
        safetyNetContribution: 6.80,
        concessionApplied: true,
        notes: 'Cannot use ACE inhibitors. Amlodipine well tolerated.'
      },
      {
        id: 'RX018',
        medication: 'Donepezil 10mg',
        doctor: 'Dr. James Wong',
        doctorProviderNumber: '2520567K',
        clinic: 'Toorak Medical Practice',
        issued: '2025-12-15',
        expires: '2026-09-15',
        refillsRemaining: 2,
        totalRefills: 5,
        status: 'Active',
        isRepeat: true,
        lastFilledDate: '2026-01-25',
        pbs: true,
        pbsItemCode: '08890N',
        pbsAuthority: true,
        streamlinedAuth: false,
        brandOptions: ['Aricept', 'Donepezil Sandoz', 'Aridon'],
        dispensedBrand: 'Aricept',
        erxScriptToken: 'ERXT-2025-018-DON',
        erxScriptType: 'eRx',
        erxBarcodeRef: '93310008901235',
        dosageInstructions: '1 tablet at bedtime',
        quantityPrescribed: 30,
        quantityDispensed: 30,
        conditionTreated: "Alzheimer's Disease",
        safetyNetContribution: 6.80,
        concessionApplied: true,
        authorityPrescriptionNumber: 'AUTH-2025-1234',
        notes: 'Authority prescription. Nursing home blister pack. MMSE reviewed quarterly.'
      }
    ],
    pbsSafetyNet: {
      currentSpend: 1650.00,
      threshold: 1694.00,
      scriptsThisYear: 24,
      safetyNetReached: false
    },
    dispensingHistory: [
      { medication: 'Amlodipine 5mg', date: '2025-07-01', quantity: 30, pbsCost: 6.80, dispensedBy: 'Alex Pharmacist' },
      { medication: 'Donepezil 10mg', date: '2025-07-05', quantity: 30, pbsCost: 6.80, dispensedBy: 'Alex Pharmacist' },
      { medication: 'Amlodipine 5mg', date: '2025-06-01', quantity: 30, pbsCost: 6.80, dispensedBy: 'Alex Pharmacist' },
      { medication: 'Donepezil 10mg', date: '2025-06-05', quantity: 30, pbsCost: 6.80, dispensedBy: 'Alex Pharmacist' }
    ],
    consent: { myHealthRecord: true, pbsClaiming: true, marketingComms: false },
    notes: 'Nursing home resident — Sunshine Aged Care. All meds packed in blister packs (Webster-pak). Delivered weekly on Mondays. Contact nursing home for any changes. Very close to PBS safety net threshold.',
    immunisations: [
      { name: 'COVID-19 (Pfizer)', date: '2024-03-01', status: 'Completed' },
      { name: 'Influenza', date: '2025-03-01', status: 'Completed' },
      { name: 'Pneumococcal', date: '2023-10-15', status: 'Completed' },
      { name: 'Shingrix (Shingles)', date: '2024-09-01', status: 'Completed' }
    ],
    pathologyResults: [
      { test: 'Blood Pressure', result: '135/80 mmHg', date: '2025-06-15', referenceRange: '< 140/90', status: 'Normal' },
      { test: 'MMSE', result: '18/30', date: '2025-06-15', referenceRange: '24-30', status: 'Below Normal' },
      { test: 'Vitamin D', result: '35 nmol/L', date: '2025-06-15', referenceRange: '> 50', status: 'Below Normal' },
      { test: 'Calcium', result: '2.3 mmol/L', date: '2025-06-15', referenceRange: '2.1-2.6', status: 'Normal' }
    ],
    sharedHealthSummary: {
      lastUpdated: '2025-06-15',
      author: 'Dr. James Wong',
      clinic: 'Toorak Medical Practice',
      summary: 'Moderate Alzheimer\'s disease (MMSE 18/30). Hypertension managed with Amlodipine (ACE inhibitors contraindicated — angioedema). Osteoporosis with vitamin D deficiency. BPH stable. Resident at Sunshine Aged Care. All medications via Webster-pak.'
    },
    adverseReactions: [
      { substance: 'Ibuprofen (NSAID)', reaction: 'Upper GI bleeding requiring hospitalisation', date: '2018-09-15', severity: 'Severe', reporter: 'Dr. James Wong', status: 'Active' },
      { substance: 'Enalapril (ACE Inhibitor)', reaction: 'Angioedema — facial and tongue swelling', date: '2016-02-20', severity: 'Severe', reporter: 'Dr. James Wong', status: 'Active' }
    ],
    carePlans: [
      { title: 'Dementia Care Plan', date: '2025-03-15', author: 'Dr. James Wong', status: 'Active', reviewDate: '2025-09-15', summary: 'Donepezil 10mg nocte. Quarterly MMSE. Structured daily routine. Falls prevention. Supervision with meals and medications. Advance care directive in place.' },
      { title: 'Residential Aged Care Plan', date: '2025-01-10', author: 'Sunshine Aged Care RN Team', status: 'Active', reviewDate: '2025-07-10', summary: 'Full assistance with ADLs. Webster-pak medications. Weekly pharmacy delivery (Mondays). Physiotherapy twice weekly. Dietitian review quarterly.' }
    ],
    diagnosticImaging: [
      { title: 'MRI Brain', date: '2024-11-20', facility: 'Melbourne Radiology', referredBy: 'Dr. James Wong', findings: 'Moderate generalised cortical atrophy, particularly temporoparietal. Moderate hippocampal volume loss bilaterally. No acute intracranial abnormality.', status: 'Reviewed' },
      { title: 'DEXA Bone Density Scan', date: '2025-02-10', facility: 'Melbourne Radiology', referredBy: 'Dr. James Wong', findings: 'T-score lumbar spine -2.8, femoral neck -2.5. Consistent with osteoporosis. Recommend continued calcium/vitamin D and consider bisphosphonate therapy.', status: 'Reviewed' }
    ],
    dischargeSummaries: [
      { hospital: 'St Vincent\'s Hospital Melbourne', admissionDate: '2018-09-10', dischargeDate: '2018-09-18', reason: 'Upper GI bleed secondary to NSAID use', summary: 'Presented with melaena and haematemesis. OGD showed gastric ulcer. Managed conservatively with IV PPI. All NSAIDs permanently contraindicated. Discharged on Pantoprazole.', followUp: 'Dr. James Wong in 2 weeks. Repeat OGD in 6 weeks.' }
    ],
    eReferrals: [
      { from: 'Dr. James Wong', to: 'Aged Care Assessment Team (ACAT)', date: '2022-02-01', reason: 'Comprehensive geriatric assessment for residential aged care placement', urgency: 'Routine', status: 'Completed' },
      { from: 'Dr. James Wong', to: 'Dr. Priya Sharma — Geriatrician', date: '2025-04-15', reason: 'Review of cognitive decline and medication optimisation', urgency: 'Routine', status: 'Accepted' }
    ],
    eventSummaries: [
      { title: 'Aged Care Medication Review (RMMR)', date: '2025-06-01', provider: 'Alex Pharmacist', clinic: 'MedFast Central Pharmacy', summary: 'Residential Medication Management Review completed. All medications appropriate. Recommended vitamin D supplementation increase to 2000 IU daily. No drug interactions identified. Webster-pak compliance confirmed.' }
    ],
    goalsOfCare: [
      { title: 'Advance Care Directive', date: '2024-06-15', author: 'Dr. James Wong', goals: ['Comfort-focused care', 'No CPR', 'No ICU admission', 'Allow natural death', 'Symptom management prioritised'], status: 'Active' }
    ],
    specialistLetters: [
      { from: 'Dr. Priya Sharma — Geriatrician', to: 'Dr. James Wong — GP', date: '2025-05-20', subject: 'Cognitive and Geriatric Review', summary: 'MMSE 18/30 (decline from 22/30 twelve months ago). Continue Donepezil. Falls risk assessment completed — low risk with current mobility aids. Vitamin D deficiency noted — increase supplementation. Review in 6 months.' },
      { from: 'Dr. Andrew Mills — Urologist', to: 'Dr. James Wong — GP', date: '2025-01-10', subject: 'BPH Follow-up', summary: 'PSA stable at 3.2 ng/mL. Moderate symptoms managed conservatively. No indication for surgical intervention at this stage. Annual PSA and review.' }
    ],
    transferDocuments: [
      { facility: 'Sunshine Aged Care', date: '2022-06-01', type: 'Residential Care Admission', summary: 'Admitted to permanent residential aged care. Level: High care. Reason: Progressive dementia with inability to manage independently. Next of kin: Margaret O\'Brien (daughter) — +61 412 555 789.' }
    ]
  }
];

// Dispensing queue — pending items at various workflow stages
export const dispensingQueue = [
  {
    id: 'DQ001',
    customerId: 'CUST001',
    customerName: 'Sarah Johnson',
    prescriptionId: 'RX001',
    medication: 'Metformin 500mg',
    erxToken: 'ERXT-2025-001-MET',
    status: 'received',
    priority: 'normal',
    receivedAt: '2026-02-15T09:15:00',
    workflowStep: 1,
    doctor: 'Dr. Sarah Smith',
    quantity: 60
  },
  {
    id: 'DQ002',
    customerId: 'CUST004',
    customerName: 'Robert Thompson',
    prescriptionId: 'RX009',
    medication: 'Atorvastatin 20mg',
    erxToken: 'ERXT-2025-009-ATO',
    status: 'verifying',
    priority: 'normal',
    receivedAt: '2026-02-15T08:45:00',
    workflowStep: 2,
    doctor: 'Dr. Peter Brown',
    quantity: 30,
    interactionWarnings: ['Monitor with Metformin — increased lactic acidosis risk at high statin doses']
  },
  {
    id: 'DQ003',
    customerId: 'CUST007',
    customerName: 'Linda Brown',
    prescriptionId: 'RX016',
    medication: 'Methylphenidate 10mg',
    erxToken: 'ERXT-2025-016-MPH',
    status: 'received',
    priority: 'high',
    receivedAt: '2026-02-15T09:30:00',
    workflowStep: 1,
    doctor: 'Dr. Rachel Green',
    quantity: 30,
    isControlledSubstance: true,
    schedule: 'S8'
  },
  {
    id: 'DQ004',
    customerId: 'CUST002',
    customerName: 'James Mitchell',
    prescriptionId: 'RX004',
    medication: 'Metoprolol 50mg',
    erxToken: 'ERXT-2025-004-MET',
    status: 'filling',
    priority: 'normal',
    receivedAt: '2026-02-15T08:00:00',
    workflowStep: 3,
    doctor: 'Dr. Robert Lee',
    quantity: 60,
    selectedBrand: 'Betaloc'
  },
  {
    id: 'DQ005',
    customerId: 'CUST005',
    customerName: 'Maria Garcia',
    prescriptionId: 'RX011',
    medication: 'Insulin Glargine',
    erxToken: 'ERXT-2025-011-INS',
    status: 'verifying',
    priority: 'high',
    receivedAt: '2026-02-15T09:00:00',
    workflowStep: 2,
    doctor: 'Dr. Helen Park',
    quantity: 1,
    pregnancyFlag: true
  },
  {
    id: 'DQ006',
    customerId: 'CUST008',
    customerName: "Michael O'Brien",
    prescriptionId: 'RX017',
    medication: 'Amlodipine 5mg',
    erxToken: 'ERXT-2025-017-AML',
    status: 'received',
    priority: 'normal',
    receivedAt: '2026-02-15T09:45:00',
    workflowStep: 1,
    doctor: 'Dr. James Wong',
    quantity: 30
  }
];

// Recently dispensed items
export const recentlyDispensed = [
  { id: 'RD001', customerId: 'CUST001', customerName: 'Sarah Johnson', medication: 'Sertraline 50mg', dispensedAt: '2026-02-15T08:30:00', dispensedBy: 'Alex Pharmacist', pbsCost: 6.80 },
  { id: 'RD002', customerId: 'CUST003', customerName: 'Emily Chen', medication: 'Symbicort Turbuhaler', dispensedAt: '2026-02-15T08:15:00', dispensedBy: 'Alex Pharmacist', pbsCost: 42.49 },
  { id: 'RD003', customerId: 'CUST006', customerName: 'David Kim', medication: 'Escitalopram 10mg', dispensedAt: '2026-02-15T07:50:00', dispensedBy: 'Alex Pharmacist', pbsCost: 6.80 },
  { id: 'RD004', customerId: 'CUST006', customerName: 'David Kim', medication: 'Sodium Valproate 500mg', dispensedAt: '2026-02-15T07:50:00', dispensedBy: 'Alex Pharmacist', pbsCost: 6.80 },
  { id: 'RD005', customerId: 'CUST002', customerName: 'James Mitchell', medication: 'Rosuvastatin 10mg', dispensedAt: '2026-02-14T16:30:00', dispensedBy: 'Alex Pharmacist', pbsCost: 6.80 },
  { id: 'RD006', customerId: 'CUST004', customerName: 'Robert Thompson', medication: 'Metformin 500mg', dispensedAt: '2026-02-14T15:45:00', dispensedBy: 'Alex Pharmacist', pbsCost: 6.80 },
  { id: 'RD007', customerId: 'CUST004', customerName: 'Robert Thompson', medication: 'Gliclazide 80mg', dispensedAt: '2026-02-14T15:45:00', dispensedBy: 'Alex Pharmacist', pbsCost: 6.80 },
  { id: 'RD008', customerId: 'CUST001', customerName: 'Sarah Johnson', medication: 'Metformin 500mg', dispensedAt: '2026-02-14T14:00:00', dispensedBy: 'Alex Pharmacist', pbsCost: 6.80 },
  { id: 'RD009', customerId: 'CUST008', customerName: "Michael O'Brien", medication: 'Donepezil 10mg', dispensedAt: '2026-02-14T11:30:00', dispensedBy: 'Alex Pharmacist', pbsCost: 6.80 },
  { id: 'RD010', customerId: 'CUST005', customerName: 'Maria Garcia', medication: 'Ferrous Sulfate 325mg', dispensedAt: '2026-02-14T10:15:00', dispensedBy: 'Alex Pharmacist', pbsCost: 6.80 }
];
